import {
  ItemPageHighDemandSignalInfoDto,
  ItemPageHighDemandSignalInfoPluginModel,
} from '@marketplace-web/item-page/item-page-data'

export const getItemPageHighDemandSignalInfoPluginModel = (
  data: ItemPageHighDemandSignalInfoDto,
): ItemPageHighDemandSignalInfoPluginModel => ({
  title: data.title,
  itemId: data.item_id,
})
